import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
  card: {
    textAlign: 'center',
    padding: '15px'
  },
  content: {
    marginTop: '-20px'
  }
}))